import { isCordova } from '@pn/core/utils/env';
import { isNil } from 'lodash-es';
import React from 'react';

export function useInterceptAnchors() {
  React.useEffect(() => {
    if (!isCordova()) return;

    document.addEventListener('click', (event) => {
      const target = event.target as HTMLElement;
      const anchor = target.closest('a');

      if (!isNil(anchor) && !isNil(anchor.href)) {
        event.preventDefault();
        window.cordova.InAppBrowser.open(anchor.href, '_system');
      }
    });
  }, []);
}
